import React from 'react';
import { healthCalculators } from './ConstantsHealthCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'حاسبات مجانية لحساب كل ما يتعلق بصحة الإنسان ولياقته البدنية - اكتشفها الآن';
const DESCRIPTION = 'استكشف مجموعتنا المختارة من حواسب الصحة واللياقة، مثل حاسبة مؤشر كتلة الجسم BMI، حاسبة السعرات الحرارية اليومية، معدل الأيض الأساسي BMR، والمزيد.';
const KEYWORDS = 'حاسبة BMI، حاسبة السعرات الحرارية، BMR، وزن مثالي، نسبة الدهون، كربوهيدرات، وحدات الطاقة الغذائية';
const OG_URL = 'https://do-calculate.com/ar/health-calculators';
function CalculatorsList() {
    return (
        <div className="container rtl-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                <u><p>إذا كنت تعرف أو ترغب في إضافة حواسب صحية أخرى، يُرجى مراسلتنا عبر البريد الإلكتروني على <b>info@do-calculate.com</b> سنكون سعداء بإضافتها! :)</p></u>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >الحاسبة</th>
                        <th >الوصف</th>
                    </tr>
                </thead>
                <tbody>
                    {healthCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
